import { ButtonText } from '@nokia-csf-uxr/ccfk/Button';
import Icon from '@nokia-csf-uxr/ccfk/Icon';
import React from 'react';
import { CONFIG } from '../config';

/**
 * Screen to alert user who can able to access to the application
 */
export default class NotAuthorizedPage extends React.Component<{},any>{

    constructor(props: {}) {
        super(props);
        this.state = {
            loading: false
        }
    }

    /**
     * Request access 
     */
    requestAccess = () => {
        window.open('mailto:'+CONFIG.requestAccessEmail+'?subject=Request access to Wavence Link Designer');
    }

    render() {
        return (
            <>
                <div className="noscroll-page">
                    <img className='full-background' src="/assets/background/img_consensus.jpg" alt-text=""></img>
                    <div className='content-center'>
                        <div className='login-content'>
                            <div className='div-horizontal-center logo-login-container'>
                            <Icon color="#124191" size={{width: 325, height: 125}} src="/assets/logo/nokia_logo.svg"></Icon>
                            <h1 className='title-login-container'><b>Wavence Link Designer</b></h1>
                            <p>You are not authorized to use Wavence Link Designer application</p>
                            <ButtonText className="secondary-action-button" onClick={() => this.requestAccess()}>Request access</ButtonText>
                            </div>
                        </div>
                    </div>
                </div>

                
            </>
        );
    }

}